// External library
import { gsap } from 'gsap'
import Player from '@vimeo/player'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

// Component
export default class VideoScroll {
    constructor () {
        this.videos = document.querySelectorAll('.video-play')

        // If there's no video to autoplay on scroll enter, return
        if (!this.videos)
            return

        this.videos.forEach(video => this.control(video))
    }

    control (el) {
        const isVideo = el.tagName === 'VIDEO'
        const isVimeo = el.tagName === 'IFRAME'

        if (!isVideo && !isVimeo)
            return

        const videoEl = isVimeo
            ? new Player(el)
            : el

        gsap.to(el, {
            scrollTrigger: {
                trigger: el,
                start: 'top bottom',
                onEnter: () => {
                    videoEl.play()
                }
            }
        })
    }
}
